import { Component, ComponentRef, inject, Injector, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CompanyModel, CompaniesService } from 'app/services/companies.service';
import { DialogService } from 'app/services/dialog.service';
import { ObjectsService } from 'app/services/objects.service';
import { ObjectsManagementDialogComponent } from '../../objects-management-dialog/objects-management-dialog.component';
import {ObjectLiteViewModel} from "../../../../models/ObjectLiteViewModel";

@Component({
    selector: 'app-entities-list-company-orchestrator',
    templateUrl: './entities-list-company-orchestrator.component.html',
    styleUrls: ['./entities-list-company-orchestrator.component.css'],
    standalone: false
})
export class EntitiesListCompanyOrchestratorComponent {
  @ViewChild("objectsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private objectsListDialog: ComponentRef<any>;

  public myEntities: ObjectLiteViewModel[] = [];
  public targetEntities: ObjectLiteViewModel[] = [];

  public IsCopyControl: boolean = false;
  public companies: CompanyModel[];
  public selectedCompanyId: number = 0;

  @Input('currentCompany')
  set onCurrentUserSet(val) {
    this.currentCompany = val;
    this.FillCurrentEntities();
  }

  public currentCompany: CompanyModel;
  @Input()
  public targetCompany: CompanyModel;
  private dialogService: DialogService;
  private translateService: TranslateService;
  private companyService = inject(CompaniesService);
  private objectService = inject(ObjectsService);
  public constructor(protected injector: Injector) {
    this.dialogService = injector.get(DialogService);
    this.translateService = injector.get(TranslateService);

    this.companyService.getCompanies().subscribe(companies => {
      const currentCompanyId = this.currentCompany?.Id;
      this.companies = currentCompanyId ? companies.filter(x => x.Id != currentCompanyId) : companies;
      this.selectedCompanyId = this.companies[0]?.Id;
      this.FillTargetEntities();
    });
  }

  public GetTargetCompany() {
    return this.companies?.find(x => x.Id == this.selectedCompanyId);
  }
  private FillCurrentEntities() {
    if (this.currentCompany?.Id)
      this.objectService.GetByCompanyId(this.currentCompany.Id).subscribe(entities => { this.myEntities = entities; });
  }

  public FillTargetEntities() {
    if (!this.selectedCompanyId) {
      this.targetEntities = [];
      return;
    }
    this.targetCompany = this.companies.find(c => c.Id == this.selectedCompanyId);
    this.objectService.GetByCompanyId(this.selectedCompanyId).subscribe(entities => {
      this.targetEntities = entities;
    });
  }

  public GetCurrentCompanyName() {
    return this.currentCompany?.Name;
  }

  protected setCurrentCompanyAsOwner() {
    if (!confirm(this.translateService.instant("Are you sure you want to move objects?")))
      return;
    this.objectService.SetOwner(this.selectedCompanyId, this.currentCompany.Id, this.targetEntities.filter(e => e.IsChecked).map(e => e.Id))
      .subscribe(() => {
        this.targetEntities.filter(e => e.IsChecked).forEach(targetEntity => {
          targetEntity.OwnerId = this.currentCompany.Id;
          this.myEntities.unshift(targetEntity);
          targetEntity.IsChecked = false;
          this.targetEntities.splice(this.targetEntities.indexOf(this.targetEntities.find(target => target.Id == target.Id)), 1);
        });
      })
  }

  protected setTargetCompanyAsOwner() {
    if (!confirm(this.translateService.instant("Are you sure you want to move objects?")))
      return;

    this.objectService.SetOwner(this.currentCompany.Id, this.selectedCompanyId, this.myEntities.filter(e => e.IsChecked).map(e => e.Id))
      .subscribe(() => {
        this.myEntities.filter(e => e.IsChecked).forEach(myEntity => {
          myEntity.OwnerId = this.targetCompany.Id;
          this.targetEntities.unshift(myEntity);
          myEntity.IsChecked = false;
          this.myEntities.splice(this.myEntities.indexOf(this.myEntities.find(te => te.Id == myEntity.Id)), 1);
        });
      })
  }

  public deleteFromCurrentUser() {
    const arr: Array<number> = [];
    this.myEntities
      .filter(e => e.IsChecked)
      .forEach(e => { arr.push(e.Id); });
  }

  public deleteFromTargetUser() {
    const arr: Array<number> = [];
    this.targetEntities
      .filter(e => e.IsChecked)
      .forEach(e => { arr.push(e.Id); });
  }
}
